export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/phone.ddf6dde9.svg","height":166,"width":165,"blurWidth":0,"blurHeight":0};